import { useContext } from 'react';
import { TaskContext, TaskContextData } from './context';

export function useTask(): TaskContextData {
    const data = useContext<TaskContextData | undefined>(TaskContext);

    if (!data) {
        throw new Error(
            "TaskContextData unavailable. Are you sure you're using this in a nested component of an TaskProvider?"
        );
    }

    return data;
}
